import { type AgentSessionResponse } from '@air/server-sdk';
import { formatUpdatedAt } from '@air/utilities';

import { WORKSPACE_AGENT_DEFAULT_SESSION_TITLE } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';

export const WORKSPACE_AGENT_SESSION_ROW_TITLE_MAX_LENGTH = 32;

export const formatWorkspaceAgentSessionRowTitle = (session: AgentSessionResponse): string => {
  const trimmedTitle = session.title?.trim();
  const title = trimmedTitle ? trimmedTitle : WORKSPACE_AGENT_DEFAULT_SESSION_TITLE;

  return title.length > WORKSPACE_AGENT_SESSION_ROW_TITLE_MAX_LENGTH
    ? `${title.slice(0, WORKSPACE_AGENT_SESSION_ROW_TITLE_MAX_LENGTH - 1)}…`
    : title;
};

export const formatWorkspaceAgentSessionRowTimestamp = (updatedAt: string): string =>
  formatUpdatedAt(new Date(updatedAt), { addSuffix: true, thresholdDays: 7 });
